import api from './api';
import { toast } from 'sonner';

export async function handleNameCorrections(nc) {
  if (!nc) return;
  if ((nc.auto || []).length > 0) {
    toast.success(
      `Rubrica aggiornata coi nomi ufficiali banca: ${nc.auto.map(a => `${a.our_name} → ${a.bank_name}`).join(' · ')}`,
      { duration: 9000 }
    );
  }
  for (const s of nc.suggestions || []) {
    const ok = window.confirm(
      `⚠️ DESTINATARIO COMPLETAMENTE DIVERSO in banca\n\nNoi: ${s.our_name}\nBanca: ${s.bank_name}\nIBAN: ${s.iban}\n\nApplicare la correzione? Nei prossimi XML verrà usato il nome della banca.`
    );
    try {
      await api.post(`/bank-name-suggestions/${s.id}/resolve`, { apply: ok });
      if (ok) toast.success(`Corretto: ${s.our_name} → ${s.bank_name}`);
    } catch {
      toast.error('Errore salvataggio correzione');
    }
  }
}
